import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useMst } from '../../../models/stores/Root';
import AppliedDiscount from '../AppliedDiscount';
import { ICartDiscountModel } from '../../../models/stores/sub-stores/Cart';
import LoadingView from '../../../pages/views/LoadingView';

const AppliedDiscountsList: React.FC = observer(() => {
  const [isRemovingDiscount, setIsRemovingDiscount] = useState(false);
  const rootStore = useMst();
  const { configuration, cart } = rootStore;

  const handleRemoveDiscountClicked = async (discount: ICartDiscountModel) => {
    setIsRemovingDiscount(true);
    const isSiteDesignerEnabled = configuration.isEnabled(
      'Feature_Site_Designer'
    );
    await cart.removePromoCode(discount, isSiteDesignerEnabled);
    await rootStore.putStripeIntentFlow();
    setIsRemovingDiscount(false);
  };

  return (
    <div className="portrait:text-sm text-base portrait:max-h-screen-10 max-h-screen-15 md:max-h-screen-25 mb-2 md:mb-4 overflow-y-auto">
      <table className="portrait:text-sm text-base table-fixed border-0 portrait:max-h-screen-10 max-h-screen-15 md:max-h-screen-25 xs:w-full">
        <LoadingView
          isOpen={isRemovingDiscount}
          message="Removing discount..."
        />
        <tbody>
          {cart.appliedDiscounts.map(discount => {
            return (
              <AppliedDiscount
                key={discount.id}
                discount={discount}
                currencySymbol={configuration.formattedCurrencySymbol}
                onDiscountRemoveClicked={handleRemoveDiscountClicked}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  );
});

export default AppliedDiscountsList;
